export const createWavHeader = (
  dataSize: number,
  sampleRate: number,
  numChannels: number,
  bitDepth: number
): ArrayBuffer => {
  const header = new ArrayBuffer(44);
  const view = new DataView(header);

  writeString(view, 0, "RIFF"); // Chunk ID
  view.setUint32(4, 36 + dataSize, true); // Chunk size
  writeString(view, 8, "WAVE"); // Format

  writeString(view, 12, "fmt "); // Subchunk1 ID
  view.setUint32(16, 16, true); // Subchunk1 size (16 for PCM)
  view.setUint16(20, 1, true); // Audio format (1 for PCM)
  view.setUint16(22, numChannels, true); // Number of channels
  view.setUint32(24, sampleRate, true); // Sample rate
  view.setUint32(28, (sampleRate * numChannels * bitDepth) / 8, true); // Byte rate
  view.setUint16(32, (numChannels * bitDepth) / 8, true); // Block align
  view.setUint16(34, bitDepth, true); // Bits per sample

  writeString(view, 36, "data"); // Subchunk2 ID
  view.setUint32(40, dataSize, true); // Subchunk2 size

  return header;
};

const writeString = (view: DataView, offset: number, text: string) => {
  for (let i = 0; i < text.length; i++) {
    view.setUint8(offset + i, text.charCodeAt(i));
  }
};

export const downsampleBuffer = (
  inputBuffer: Float32Array,
  inputSampleRate: number,
  outputSampleRate: number
): Float32Array => {
  if (outputSampleRate >= inputSampleRate) {
    return inputBuffer; // No need to downsample if rates are equal or increasing
  }

  const sampleRatio = inputSampleRate / outputSampleRate;
  const newLength = Math.round(inputBuffer.length / sampleRatio);
  const downsampledBuffer = new Float32Array(newLength);

  for (let i = 0; i < newLength; i++) {
    downsampledBuffer[i] = inputBuffer[Math.floor(i * sampleRatio)];
  }

  return downsampledBuffer;
};
